export const Trad1 = require("./tradicional-1.png")
export const Trad2 = require("./tradicional-2.png")